import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import './Breadcrumb.css';

const Breadcrumb = (props) => {
	const items = props.items || [];
	const lis = items.map( (item, index) => {
		const { path, title } = item;
		const el = ( path )?
			<NavLink to={path}>{title}</NavLink> : 
			<span>{title}</span>;
		
		return <li key={index}>{el}</li>
	});
	return (
		<div className="Breadcrumb">
			<div className="spacer spacer-after"></div>
			<div className="spacer spacer-before"></div>
			<ul>
				{lis}
			</ul>
		</div>
	)
}

Breadcrumb.propsType = {
	items: PropTypes.array
}

export default Breadcrumb;


// WEBPACK FOOTER //
// ./src/components/common/Breadcrumb.jsx